<template>
  <div>
    <div v-if="!loading">
      <div class="font-weight-bold pa-0 pt-2">Payment Method</div>
      <v-select
        dense
        v-model="selectedPaymentMethod"
        :hint="getDescription()"
        :persistent-hint="true"
        :items="getPaymentMethods(buySell)"
        item-text="title"
        item-value="id"
        label="Payment Methods"
        single-line
        return-object
        :error-messages="achError()"
        :rules="[...requireObjectField, ...requireAchInfo]"
      >
        <template slot="append-outer">
          <template v-if="ACH_PAYMENT_IDS.includes(selectedPaymentMethod.netsuite_internalId)">
            <v-icon @click="addBankingInfo">mdi-plus</v-icon>
            <v-icon @click="achDebitDateDialog = true">mdi-calendar-month-outline</v-icon>
          </template>
        </template>
        <template v-slot:message="{ message, key }">
          <span v-html="message"></span>
        </template>
      </v-select>
      <v-dialog v-model="achDebitDateDialog" max-width="340">
        <v-card>
          <v-card-title>Set ACH Debit Date</v-card-title>
          <v-card-text>
            <p><strong>Specify ACH Debit Date Below.</strong></p>
            <v-date-picker
              v-model="achDebitDate"
              :allowed-dates="(val) => { return allowedDates(val, MAX_ACH_DEBIT_DAYS, nextMarketCloseRaw()) }"
            ></v-date-picker>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!loading"
              color="white"
              @click="achDebitDateDialog = false"
              class="mr-2 mb-1"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              class="mb-1 lighten-1"
              @click="saveAchDebitDate"
              :loading="loading"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-progress-linear
      class="mt-4 mb-4"
      indeterminate
      v-else
    ></v-progress-linear>
  </div>
</template>

<script>
import companyMixin from '@/mixins/company'
import orderMixin from '@/mixins/order'
import {mapGetters} from 'vuex'
import {get} from 'lodash'
import {BankTranTypes, BankAccountStates, MAX_ACH_DEBIT_DAYS, ACH_PAYMENT_IDS} from '@/util/constants'

export default {
  mixins: [orderMixin, companyMixin, orderMixin],
  props: ['buySell', 'companyId'],
  data() {
    return {
      loading: true,
      achDebitDate: null,
      MAX_ACH_DEBIT_DAYS,
			ACH_PAYMENT_IDS,
      achDebitDateDialog: null,
      requireAchInfo: [
        (v) => !ACH_PAYMENT_IDS.includes(v.id) ||
          ( this.buySell === `buy` &&
            this.bankAccountStateByTranType(BankTranTypes.DEBIT) !==
            BankAccountStates.NOT_ACTIVE) ||
          ( this.buySell === `sell` &&
            this.bankAccountStateByTranType(BankTranTypes.DEPOSIT) !==
            BankAccountStates.NOT_ACTIVE) ||
          `We do not have your ACH information on file. Click the (+) icon to add it.`,
      ],
    }
  },
  watch: {
    companyId: {
      handler() {
        this.init()
      },
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    saveAchDebitDate() {
      this.$store.commit('updateCartField', {
        path: `${this.buySell}.achDebitDate`,
        value: this.achDebitDate,
      })
      this.achDebitDateDialog = false
    },
    achError() {
      const error = this.requireAchInfo[0](this.selectedPaymentMethod)
      if (error === true) return undefined
      return error
    },
    getDescription() {
      if (ACH_PAYMENT_IDS.includes(get(this.selectedPaymentMethod, `netsuite_internalId`)) && this.buySell === `buy`) {
        return `Your payment will be debited on <strong>${(this.achDebitDate) ? this.$options.filters.toDate(this.achDebitDate) : `the next business day`}</strong> from the primary bank account you have on file.<br> You may schedule a different debit date by clicking the calendar icon. You may add additional banking info by clicking the plus icon.`;
      }
      return this.selectedPaymentMethod.description
    },
    async init() {
      this.loading = true
      if (this.$store.getters['getCartField'](`${this.buySell}.achDebitDate`)) {
        this.achDebitDate = this.$store.getters['getCartField'](
          `${this.buySell}.achDebitDate`
        )
      } else {
        this.achDebitDate = this.nextMarketClose()
        this.saveAchDebitDate()
      }
      if (!get(this, `selectedPaymentMethod.id`)) {
        await this.$store.dispatch('fetchDefaultPaymentMethods')
        const defaultPaymentMethodNetsuiteId =
          this.buySell === `buy`
            ? this.getSelectedCompany.defaultPaymentMethodBuy
            : this.getSelectedCompany.defaultPaymentMethodSell
        const paymentMethods = this.getPaymentMethods(this.buySell)
        const match = paymentMethods.filter(
          (x) =>
            parseInt(x.netsuite_internalId) === defaultPaymentMethodNetsuiteId
        )
        if (match[0]) {
          this.selectedPaymentMethod = match[0]
        }
      }
      this.$emit('loaded')
      this.loading = false
    },
    addBankingInfo() {
      this.$emit('addBankingInfo')
    },
  },
  computed: {
    ...mapGetters(['getSelectedCompany']),
    selectedPaymentMethod: {
      get() {
        return this.$store.getters['getCartField'](
          `${this.buySell}.selectedPaymentMethod`
        )
      },
      set(value) {
        this.$store.commit('updateCartField', {
          path: `${this.buySell}.selectedPaymentMethod`,
          value,
        })
      },
    },
  },
}
</script>
